<template>
  <section class="new__wrapper">
    <h1 class="new__header">New Courses</h1>
    <div class="new__courses-wrapper">
      <CourseTile
        v-for="course in courses"
        :key="course.id"
        :course="course"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </div>
  </section>
</template>

<script>
import CourseTile from '@/components/layout/CourseTile.vue'

export default {
  name: 'New',
  components: {
    CourseTile,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.new {
  &__header {
    color: var(--white);
    text-transform: capitalize;
  }
  &__wrapper {
    position: relative;
    padding: 150px 25px;
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__courses-wrapper {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 8px;
    }
    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
}
</style>
